import { createAction } from "redux-actions";

export default createAction("PATTERN_DEMO_LOADED");
